import { ReceiptClockIcon } from './ReceiptClockIcon';

/**
 * author: Jeff Anders
 * id 74B3AD4D-BDC1-4C72-9151-54D295195D39
 * name receipt-clock
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/receipt-clock.svg
 * tags
 */
export const ReceiptPendingIcon = ReceiptClockIcon;
export default ReceiptPendingIcon